import script from "./hardware-monitor-stat-card.vue?vue&type=script&setup=true&lang=ts"
export * from "./hardware-monitor-stat-card.vue?vue&type=script&setup=true&lang=ts"

import "./hardware-monitor-stat-card.vue?vue&type=style&index=0&id=22afc0c3&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22afc0c3"]])

export default __exports__